// src/config/auth.config.js

/**
 * Centralized Auth0 configuration
 * All auth-related settings should be managed here
 */

const getEnvVar = (key, fallback = '') => {
  const value = process.env[key];
  if (!value && !fallback) {
    console.warn(`Missing environment variable: ${key}`);
  }
  return value || fallback;
};

export const auth0Config = {
  domain: getEnvVar('REACT_APP_AUTH0_DOMAIN', 'login.indexerglue.com'),
  clientId: getEnvVar('REACT_APP_AUTH0_CLIENT_ID', 'fSrnR4yIyDPcwHKl71vwjQhwl9t8UtNw'),
  audience: getEnvVar('REACT_APP_AUTH0_AUDIENCE', 'https://api.indexerglue.com/api/v1/'),
  redirectUri: getEnvVar('REACT_APP_AUTH0_REDIRECT_URI', window.location.origin),
  logoutRedirectUri: getEnvVar('REACT_APP_AUTH0_LOGOUT_REDIRECT_URI', window.location.origin),
  
  // Scopes requested for the application
  scope: 'openid profile email read:users write:users read:indexers write:indexers delete:indexers delete:apikeys generate:user_keys read:apikeys write:apikeys',
  
  // OAuth settings
  useRefreshTokens: true,
  cacheLocation: 'localstorage', // Use localstorage to persist PKCE verifier across redirects
  
  // Note: If passkeys don't work with localstorage, the workaround is to:
  // 1. Add a /callback route that renders Auth0's callback handler
  // 2. Or use memory cache with a service worker
};

export const apiConfig = {
  baseUrl: getEnvVar('REACT_APP_API_BASE_URL', 'https://api.indexerglue.com/api'),
};

// Route paths
export const routes = {
  home: '/',
  login: '/login',
  dashboard: '/dashboard',
  accountInfo: '/accountinfo',
  apiDocs: '/apidocumentation',
  howTo: '/HowTo',
  stats: '/stats',
};
